/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAccountProfileItem, IAccountProfileViewProps } from './nos-account-profile';

const AccountProfileSection: React.FC<IAccountProfileItem> = ({ AccountProfileItem, heading, links, description }) => {
    return (
        <Node {...AccountProfileItem}>
            {heading}
            {description}
            {links}
        </Node>
    );
};

const AccountProfileView: React.FC<IAccountProfileViewProps> = props => {
    const {
        AccountProfile,
        infoMessageBar,
        accountProfileWrapper,
        heading,
        emailSection,
        nameSection,
        customerAttributesWrapper,
        customerAttributesSection,
        infoText
    } = props;

    return (
        <Module {...AccountProfile}>
            {infoMessageBar}
            {accountProfileWrapper && (
                <Node {...accountProfileWrapper}>
                    {heading}
                    <AccountProfileSection {...emailSection} />
                    <AccountProfileSection {...nameSection} />
                    {infoText}
                </Node>
            )}
            {customerAttributesWrapper && <Node {...customerAttributesWrapper}>{customerAttributesSection}</Node>}
        </Module>
    );
};

export default AccountProfileView;
